// include npm plugin packages
window.$ = window.jQuery = require('jquery');
window.L = require('leaflet');
require('jquery-easing');
require('slick-carousel');
window.Cookies = require('js-cookie');
window.GMaps = require('gmaps');
window.Pikaday = require('pikaday');
window.moment = require('moment');
require('moment/locale/nl');
require('imagesloaded');
window.jQueryBridget = require('jquery-bridget');
window.Isotope = require('isotope-layout');


// include local plugin packages
require('./plugins/nivo-lightbox/nivo-lightbox.js');


window.removeCookie = function (cookie) {
    Cookies.remove(cookie);
};

window.setCookie = function (cookie, value, expires) {
    Cookies.set(cookie, value, { expires: expires });
};

/*
** Require local packages
*/
var App = require('./lib/dbk-app/app');
/*
** Initialize the app.
** Example: If you have a template called 'templates-examples.php' add it here as: template_examples
** this code will only get executed on templates-examples.php
*/
var app = new App({
    global: require('./modules/global'),
    front_page: require('./modules/front-page')
});
jQuery(document).ready(app.loadEvents);
